import './ccf-flash-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfFlashIconProps extends SvgIconProps {}

/**
 * CcfFlashIcon used to disply Quick replies icon in the app space panel
 * @param props - CcfFlashIconProps
 * @example -- <CcfFlashIcon />
 */
export function CcfFlashIcon(props: CcfFlashIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="ic_quick_replies" clipPath="url(#clip-ic_quick_replies)">
        <g id="ic_app_quickreplies" transform="translate(-15.686 1.161)">
          <path id="lightning" d="M20.8,8.8H12V0L3.2,13.2H12V22Z" transform="translate(14.686)"/>
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfFlashIcon;
